// extracted by mini-css-extract-plugin
export var brand = "_s-9";
export var button = "_s-0";
export var chevron = "_s-v";
export var chevronButton = "_s-w";
export var content = "_s-n";
export var danger = "_s-g";
export var dangerOutlined = "_s-h";
export var dark = "_s-l";
export var darkTheme = "_s-c";
export var extraSmall = "_s-4";
export var fullWidth = "_s-8";
export var ghost = "_s-d";
export var gray = "_s-t";
export var icon = "_s-p";
export var iconButton = "_s-s";
export var iconButtonBorder = "_s-x";
export var iconButtonBorderDark = "_s-y";
export var iconButtonBorderLight = "_s-z";
export var iconLeft = "_s-q";
export var iconRight = "_s-r";
export var large = "_s-1";
export var light = "_s-m";
export var medium = "_s-2";
export var micro = "_s-5";
export var nano = "_s-7";
export var outlined = "_s-k";
export var pending = "_s-a";
export var primary = "_s-i";
export var shadow = "_s-o";
export var small = "_s-3";
export var solidLight = "_s-e";
export var solidLightBrand = "_s-f";
export var spinner = "_s-u";
export var transparent = "_s-j";
export var warning = "_s-b";
export var wideNano = "_s-6";